import isEqual from 'react-fast-compare';

import {MODEL_RUN_SOURCE} from 'constants/AnalyticsConstants';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import {
  buildPredictionBatchName,
  moleculeId,
  submitBulkPrediction,
} from 'model-hub/scientific-models/input-forms/BulkPredictionUtils';
import {MODEL_CATEGORY, type ScientificModelNode} from 'model-hub/scientific-models/ScientificModelMetadata';

export function getMoleculePropertyPredictionModels(
  models: ReadonlyArray<ScientificModelNode>
): Array<ScientificModelNode> {
  return models.filter(
    (model) =>
      model.category === MODEL_CATEGORY.PROPERTY_PREDICTION && isEqual(model.inputTypes, ['molecule'])
  );
}

export function resolvePropertyPredictionFolderId(moleculeFolderId: string | null): string | undefined {
  return FolderDefaults.get(FolderDefaultsKey.BULK_MODEL_PREDICTION) ?? moleculeFolderId ?? undefined;
}

export async function requestPropertyPrediction({
  folderId,
  model,
  moleculeId: moleculeApiId,
}: {
  folderId?: string;
  model: ScientificModelNode;
  moleculeId: string;
}): Promise<void> {
  await submitBulkPrediction({
    folderId,
    model,
    name: buildPredictionBatchName(model),
    predictionConfigs: [{component: moleculeId(moleculeApiId)}],
    source: MODEL_RUN_SOURCE.MOLECULE_PROPERTY_PREDICTION_TAB,
  });
}
